import React, { useEffect, useRef } from 'react';
import './OurTeamHero.scss';
import { teamMembers } from '../../Utils/OurTeamList';

const OurTeamHero = () => {
  const videoEl = useRef(null);

  const attemptPlay = () => {
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch((error) => {
        console.error('Error attempting to play', error);
      });
  };

  useEffect(() => {
    attemptPlay();
  }, []);

  return (
    <div className="container">
      <div className="our-team-hero">
        <h2
          className="our-team-title"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-once="true">
          We are a leader in digital <br />
          innovation and brand development.
        </h2>
        <section className="team-section">
          {teamMembers?.map((member, index) => (
            <div className="team-card" key={index}>
              {console.log(member)}
              <div className="image-container">
                <img
                  src={member?.image}
                  alt={member?.title}
                  title={member?.name ? member.name : ''}
                  className="profile-img"
                />
              </div>
              <p className="member-title">{member?.title}</p>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

export default OurTeamHero;
